import { action } from '@ember/object';
import Service from '@ember/service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
// import { w } from '@ember/string';

export default class EditorActiveService extends Service {
  @service store;
  @service quill;

  @tracked activeEditorId = null;
  @tracked activeItem = null;

  @action
  setActiveEditor(editor_id) {
    // console.log(editor_id);
    // console.log('active editor set was', editor_id);
    this.activeEditorId = editor_id;
  }

  @action
  setActiveItem(item_id) {
    // console.log('active item set was', item_id);
    this.activeItem = item_id;
  }

  @action
  clearActiveEditor() {
    this.activeEditorId = null;
    this.activeItem = null;
  }

  @action
  moveFocusUpByOneItem() {
    const containers = document.querySelectorAll(
      '#content .ql-container:not([data-cy=comment-input])',
    );
    const containerArray = Array.from(containers);

    const currentIndex = containerArray.findIndex(
      (container) => container.id === this.activeEditorId,
    );

    if (currentIndex > 0) {
      const previousContainer = containerArray[currentIndex - 1];
      this.activeEditorId = previousContainer.id;
      const itemId = previousContainer.getAttribute('data-item-id');
      this.activeItem = itemId;

      const editor = this.quill.instance(this.activeEditorId);
      editor.setSelection(editor.getLength() - 1, 0);
    }
  }

  @action
  moveFocusDownByOneItem() {
    const containers = document.querySelectorAll(
      '#content .ql-container:not([data-cy=comment-input])',
    );
    const containerArray = Array.from(containers);

    const currentIndex = containerArray.findIndex(
      (container) => container.id === this.activeEditorId,
    );

    if (currentIndex !== -1 && currentIndex < containerArray.length - 1) {
      const nextContainer = containerArray[currentIndex + 1];
      this.activeEditorId = nextContainer.id;
      const itemId = nextContainer.getAttribute('data-item-id');
      this.activeItem = itemId;

      const editor = this.quill.instance(this.activeEditorId);
      editor.setSelection(editor.getLength() - 1, 0);
    }
  }
}
